import React, { useEffect, useState } from "react";
import Link from "react-router-dom/Link.js";
import useFetchDataWithPagination from "../../../utility/useFetchDataWithPagination.js";
import FooterImage from "../../../asset/img/Footer.jpg";

const Footer = () => {
  const [quickLinks, setQuickLinks] = useState([]);
  const {
    data,
    isLoading: loading,
    paginate,
    refreshSearch,
  } = useFetchDataWithPagination("quick-links");

  useEffect(() => {
    if (data?.data?.data) {
      setQuickLinks(data.data.data);
    }
  }, [data]);
  return (
    <footer>
      <div className="footer-content">
        <div className="footer-section">
          <h3>À propos de l'ONPR</h3>
          <p>
            Office national des pensions et risques professionnelles des
            fonctionnaires, des magistrats et des agents de l'ordre judiciaire.
          </p>
        </div>
        <div className="footer-section">
          <h3>Liens Utiles</h3>

          {quickLinks.map((link) => (
            <a
              key={link.id}
              href={link.box}
              target="_blank"
              rel="noopener noreferrer"
            >
              {link.name_fr}
            </a>
          ))}
          {/* <a
            target="_blank"
            rel="noopener noreferrer"
            href="https://presidence.gov.bi/"
          >
            Présidence de la République
          </a>
          <a
            target="_blank"
            rel="noopener noreferrer"
            href="https://assemblee.bi/"
          >
            Assemblée Nationale
          </a>
          <a
            target="_blank"
            rel="noopener noreferrer"
            href="http://www.vicepresidence2.gov.bi/"
          >
            2ème Vice-Présidence
          </a>

          <a
            target="_blank"
            rel="noopener noreferrer"
            href="https://inss.gov.bi/"
          >
            INSS
          </a>
          <a
            target="_blank"
            rel="noopener noreferrer"
            href="http://www.ecassa.org/"
          >
            ECASSA
          </a>
          <a
            target="_blank"
            rel="noopener noreferrer"
            href="https://www.issa.int/fr"
          >
            ISSA
          </a>

          <a
            target="_blank"
            rel="noopener noreferrer"
            href="http://www.mfpburundi.bi"
          >
            MFP Burundi
          </a>
          <a
            target="_blank"
            rel="noopener noreferrer"
            href="http://minfpte.gov.bi/"
          >
            Ministère du Travail, de la Fonction Publique et de la Sécurité
            Sociale
          </a>
          <a target="_blank" rel="noopener noreferrer" href="http://www.obr.bi">
            OBR
          </a>
          <a
            target="_blank"
            rel="noopener noreferrer"
            href="http://www.armp.bi"
          >
            ARMP
          </a> */}
        </div>
        <div className="footer-section">
          <h3>Contact-ONPR Siege</h3>
          <p>
            <i className="pi pi-map-marker"></i> Quartier ROHERO I
            <br />
            Chaussée du P.L.RWAGASORE, N°187
          </p>
          <p>
            <i className="pi pi-phone"></i> (+257) 22 27 62 29
          </p>
          <p>
            <i className="pi pi-box"></i> B.P : 3079 Bujumbura II
          </p>
          <p>
            <i className="pi pi-envelope"></i> info@onpr.bi
          </p>
          <p>
            <Link
              to="/contacts"
              style={{
                fontSize: "1.1rem",
                fontWeight: "bold",
                color: "#FFFFFF",
              }}
            >
              <i className="pi pi-arrow-circle-right"></i>Voir tout les contacts
              de ONPR
            </Link>
          </p>
          {/* <a
            target="_blank"
            rel="noopener noreferrer"
            href="https://www.onpr.bi:2096/"
          >
            <i className="pi pi-globe"></i> WebMail
          </a> */}
        </div>
        <div className="footer-section">
          <h3>Suivez-nous</h3>
          <div
            className="social-links"
            style={{ justifyContent: "flex-start", marginTop: "15px" }}
          >
            <a href="https://www.facebook.com/onpr.bi" className="facebook">
              <i className="pi pi-facebook"></i>
            </a>
            <a href="https://x.com/Onpr2018" className="twitter">
              <i className="pi pi-twitter"></i>
            </a>
            <a
              href="https://www.youtube.com/@onprburundi8558"
              className="youtube"
            >
              <i className="pi pi-youtube"></i>
            </a>
            <a
              href="https://www.linkedin.com/company/onpr-bi"
              className="Whatsapp"
            >
              <i className="pi pi-whatsapp"></i>
            </a>
          </div>
        </div>
      </div>
      <div className="footer-bottom">
        <img src={FooterImage} alt="ONPR" />
        {/* <p>
          &copy; 2025 ONPR - OFFICE NATIONAL DES PENSIONS ET RISQUES
          PROFESSIONNELS - Tous droits réservés
        </p> */}
      </div>
    </footer>
  );
};

export default Footer;
